import React from "react";
import SizeGrid from "../components/Size/SizeGrid";

interface Props {
  Title: string;
}

interface State {}

class Sizes extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  componentDidMount(): void {}

  render() {
    return (
      <div className="wrapper">
        <div className="section latest-offers">
          <div className="container">
            <h3 className="section-title">{this.props.Title}</h3>
            <hr />
            <SizeGrid key={"SizeGrid"} Title={"Size Values"} MaxRows={100} />
          </div>
        </div>
      </div>
    );
  }
}

export default Sizes;
